import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { map, tap, catchError } from 'rxjs/operators';
import { InvestigationEntity } from '../../../domain/entities/investigation.entity';
import { InvestigationsRepository } from '../../../infrastructure/repositories/investigations.repository';
import { InvestigationsState } from '../../states/investigations.state';
import { CreateInvestigationResult } from './create-investigation.result';

@Injectable({ providedIn: 'root' })
export class CreateInvestigationUseCase {
  private readonly _repository = inject(InvestigationsRepository);
  private readonly _state = inject(InvestigationsState);

  public execute(data: Omit<InvestigationEntity, 'id' | 'investigationNumber' | 'createdOn' | 'updatedOn'>): Observable<CreateInvestigationResult> {
    this._state.setSavingInvestigation(true);
    this._state.setErrorInvestigation(null);

    return this._repository.createInvestigation(data).pipe(
      tap(() => this._state.setSavingInvestigation(false)),
      map((result) => ({
        investigationId: result.investigationId,
        investigationNumber: result.investigationNumber,
      })),
      catchError((error) => {
        this._state.setErrorInvestigation(error.message ?? 'Failed to create investigation');
        this._state.setSavingInvestigation(false);
        return throwError(() => error);
      }),
    );
  }
}
